<template>
  <el-dialog
    title="请选择新的设备号"
    :visible="dialogShow"
    @open="dialogOpen"
    @close="dialogClose"
    width="320px"
    class="achievement-create-exam"
    :close-on-click-modal="false"
  >
    <!-- 选择需要修改的 -->
    <deviceCreateList
      :unboundList="unboundList"
      :editStudentInfo="editStudentInfo"
      ref="achievementCreateClass"
      v-show="step == 1"
      @close="dialogClose"
    />
  </el-dialog>
</template>

<script>
import deviceCreateList from "../device-create-list/device-create-list.vue";

export default {
  data() {
    return {
      dialogShow: false,
      step: 1,
      gradeInfo: {},
      classList: [],
      failList: [],
    };
  },
  watch: {
    isCreateEditShow() {
      this.dialogShow = this.isCreateEditShow;
    },
  },
  inject: ["refresh"],
  props: {
    isCreateEditShow: {
      type: Boolean,
      default: false,
    },
    unboundList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    editStudentInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    deviceCreateList,
  },
  created() {},
  methods: {
    // 打开弹出窗口
    dialogOpen() {},
    // 关闭弹出窗口
    dialogClose() {
      // 刷新
      this.refresh();
      this.$emit("update:isCreateEditShow", false);
    },
  },
};
</script>

<style scoped lang="scss">
@import "./device-create-edit.scss";
</style>